import { frontendURL } from '../../../helper/URLHelper';

const ClinicalDashboardOverview = () =>
  import('./pages/ClinicalDashboardOverview.vue');

export const routes = [
  {
    path: frontendURL('accounts/:accountId/clinical-dashboard'),
    name: 'clinical_dashboard',
    meta: {
      permissions: ['administrator', 'agent', 'custom_role'],
    },
    component: ClinicalDashboardOverview,
  },
];
